import { Tag } from "components/DesignSystem/Tag/Tag";
import { ClockCountdown } from "components/icons/ClockCountdown";
import { DISPLAY_DATE } from "constants/date";
import dayjs from "dayjs";

type AccessRequestStatusData = {
  requested_on: string;
  is_received: boolean;
};

type AccessRequestStatusProps = { data?: AccessRequestStatusData | null };

const PENDING_LABEL = "Pending";
const RECEIVED_LABEL = "Received";

export const AccessRequestStatus = ({ data }: AccessRequestStatusProps) => {
  if (!data) {
    return null;
  }

  return (
    <div className="t-flex t-items-center t-gap-2 t-mb-2 t-flex-wrap">
      <span className="t-flex t-items-center t-gap-1.5 t-text-body-sm t-text-text-30">
        <ClockCountdown />
        Requested from customer on{" "}
        {dayjs(data.requested_on).format(DISPLAY_DATE)}
      </span>
      <Tag
        tagType={data.is_received ? "green" : "orange"}
        icon={false}
        size="small"
        rounded
      >
        {data.is_received ? RECEIVED_LABEL : PENDING_LABEL}
      </Tag>
    </div>
  );
};
